import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaArrowRight } from "react-icons/fa";
import "./BrandIdentity.css";
import brandImage from "../../../../assets/ScrollComponents/img (3).png";
import { Link } from 'react-router-dom';


const Digital = () => {
  return (
    <section
      className="brand-identity-section"
      style={{ backgroundColor: "#F15722" }}
    >
      <Container className="h-100 d-flex flex-column justify-content-center">
        {/* --- MOBILE ONLY TITLE (Visible on < lg screens) --- */}
        {/* Places Title at the very top for mobile view */}
        <div className="d-block d-lg-none pb-4">
          <h2 className="bi-heading mobile-heading">
            Digital &
            <br />
            Performance <br />
            Marketing
          </h2>
        </div>

        <Row className="h-100 flex-grow-1">
          {/* LEFT COLUMN: Text Content */}
          {/* Order-2 on mobile (below image), Order-1 on Desktop */}
          <Col
            lg={6}
            className="order-2 order-lg-1 d-flex flex-column justify-content-center py-3 py-lg-0"
          >
            <div className="content-wrapper">
              {/* DESKTOP ONLY TITLE */}
              <h2 className="bi-heading d-none d-lg-block">
                Digital & <br />
                Performance
                <br />
                Marketing
              </h2>

              <p className="bi-description">
             We drive brand growth through data-driven digital marketing strategies that focus on visibility, engagement, and performance. Our approach combines SEO, social media, and campaign optimization to deliver measurable business results.
              </p>

              <div className="bi-link-wrapper mt-4 mt-lg-5">
                <div className="bi-divider"></div>
                  <Link to="/contact" className="bi-link">
                  Learn more <FaArrowRight className="ms-3 arrow-icon" />
                </Link>
              </div>
            </div>
          </Col>

          {/* RIGHT COLUMN: Image */}
          {/* Order-1 on mobile (above text), Order-2 on Desktop */}
          <Col
            lg={6}
            className="order-1 order-lg-2 d-flex align-items-center justify-content-center h-100 py-3 py-lg-5"
          >
            <div className="bi-image-wrapper">
              <img
                src={brandImage}
                alt="Brand Identity Mockup"
                className="bi-img"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Digital;
